/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Fail_Delivery_PlaceholderInputs */

const vi_order_fail_delivery_placeholder = /** @type {(inputs: Order_Fail_Delivery_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lý do giao thất bại...`)
};

/**

* @param {Order_Fail_Delivery_PlaceholderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_fail_delivery_placeholder = /** @type {((inputs?: Order_Fail_Delivery_PlaceholderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Fail_Delivery_PlaceholderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_fail_delivery_placeholder(inputs)
});